/** @format */
import { ChangeDetectionStrategy, Component, Inject, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FudisDialogService } from '@funidata/ngx-fudis';
import { StateService } from '@uirouter/core';
import { Attainment, CourseUnit, CustomCourseUnitAttainment } from 'common-typescript/types';
import { StudyBoxType } from 'sis-components';
import { PlanStructureData } from '../plan-data.service';

export function unallocatedCourseUnitAttainmentsDialogOpener(): (
    data: PlanStructureData,
) => MatDialogRef<UnallocatedCourseUnitAttainmentsDialogComponent> {
    const dialogService = inject(FudisDialogService);
    return (data: PlanStructureData) => dialogService.open(UnallocatedCourseUnitAttainmentsDialogComponent, { data });
}

export interface UnallocatedAttainment extends Attainment {
    courseUnit?: CourseUnit;
}

@Component({
    selector: 'app-unallocated-course-unit-attainments-dialog',
    standalone: false,
    templateUrl: './unallocated-course-unit-attainments-dialog.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnallocatedCourseUnitAttainmentsDialogComponent implements OnInit {
    unallocatedCourseUnitAttainments: UnallocatedAttainment[];
    unallocatedCustomCourseUnitAttainments: CustomCourseUnitAttainment[];
    protected readonly StudyBoxType = StudyBoxType;

    constructor(
        private readonly dialogService: FudisDialogService,
        private readonly stateService: StateService,
        @Inject(MAT_DIALOG_DATA) readonly data: PlanStructureData,
    ) {}

    ngOnInit(): void {
        const { validatablePlan, unplannedAttainments } = this.data;

        this.unallocatedCourseUnitAttainments = Object.values(unplannedAttainments.courseUnitAttainments).map(attainment => ({
            ...attainment,
            courseUnit: validatablePlan.getCourseUnit(attainment.courseUnitId),
        }));

        this.unallocatedCustomCourseUnitAttainments = unplannedAttainments.customCourseUnitAttainments;
    }

    onAddToPlanButtonClick(courseUnit: CourseUnit) {
        this.stateService.go('student.logged-in.add-to-plan', {}, { custom: { courseUnit, planId: this.data.plan.id } });
        this.dialogService.close();
    }

    onAddCustomAttainmentToPlanClick(customCourseUnitAttainment: CustomCourseUnitAttainment) {
        this.stateService.go('student.logged-in.add-to-plan', {}, { custom: { customCourseUnitAttainment, planId: this.data.plan.id } });
        this.dialogService.close();
    }

    getCustomCourseUnitCredits(attainment: CustomCourseUnitAttainment) {
        return { min: attainment.credits, max: attainment.credits };
    }
}
